export const COMPANY_IDS = {
  AMK: "8A613C15-35E4-471F-91CC-972F933331D7",
  GL: "09ECD4F0-AE58-4539-8E8F-9275B1859A19",
  RN: "5E65A955-7B1A-446C-B24F-CFE576BF52D7",
  LMK: "6A2D0B60-84D6-4830-9945-58D518D27AC2",
} as const;

export type CompanyId = (typeof COMPANY_IDS)[keyof typeof COMPANY_IDS];
